import { Component, OnInit } from "@angular/core";
import { DataService } from "./../../data.service";
import { Router, ActivatedRoute } from "@angular/router";
import { GUID } from "./../../guid";
import { ToastService } from "ng-uikit-pro-standard";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";

interface Profile {
  name: string;
  id: string;
}

// Define an interface for the page layout assignment data
interface PageLayoutAssignment {
  profilename: string;
  profileid: string;
  layoutid: string; // Assuming a layout ID property
  selected: boolean;
}

@Component({
  selector: "app-layoutassignment",
  templateUrl: "./layoutassignment.component.html",
  styleUrls: ["./layoutassignment.component.scss"],
})
export class LayoutassignmentComponent implements OnInit {
  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    // private sharedDataService: SharedDataService,
    private router: Router,
    private toastrService: ToastService
  ) {}

  selectedLayout: string = ""; // Declare and initialize the selectedLayout property
  selectedLayoutValue: string = "";
  loaded: boolean = false;
  selectedId: any;
  selectedName: any;
  selectedElement: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  profileList = [];
  profileLayoutList = [];
  recordTypeList = [];
  metaProfileLayout = [];
  layoutList = [];
  metalayoutList = [];
  recordTypeLayout = [];
  mode = "";
  metaobjectId = "";
  metaobjectName = "";
  metaProfileLayoutId = "";
  metaProfileLayoutWebId = "";
  recordtypeLayoutAssignment = [];
  guid: GUID;

  // dbData={
  //   obj:'',
  //   haverecordtype:true,
  //   pagelayoutassignment:[
  //     {
  //       profilename:'profile aaa',
  //       profileid:'xmcnvywe',
  //       layouts:[
  //         {
  //           recordtypeid:'adfuelr',
  //           recordtypename:'aaa recordtype',
  //           layoutname:'aaa layout',
  //           layoutid:'lalsiuow'
  //         },
  //         {
  //           recordtypeid:'adfuelr',
  //           recordtypename:'aaa recordtype',
  //           layoutname:'aaa layout',
  //           layoutid:'lalsiuow'
  //         },
  //         {
  //           recordtypeid:'adfuelr',
  //           recordtypename:'aaa recordtype',
  //           layoutname:'aaa layout',
  //           layoutid:'lalsiuow'
  //         },{
  //           recordtypeid:'adfuelr',
  //           recordtypename:'aaa recordtype',
  //           layoutname:'aaa layout',
  //           layoutid:'lalsiuow'
  //         }
  //       ]
  //     }
  //   ],

  // }
  checkboxState = {};

  dbData = {};
  dbData1 = {};
  profileLists: Profile[] = []; // Populate this with your profile data
  pageLayoutAssignments: PageLayoutAssignment[] = [];
  // objectName = 'Account'
  // layoutId = 'aslfslkd'
  allSelected = {};
  ngOnInit() {
    this.dbData = {
      obj: this.metaobjectName,
      haverecordtype: true,
      pagelayoutassignment: [],
    };

    this.dbData1 = {
      obj: this.metaobjectName,
      haverecordtype: false,
      layoutassignment: [],
    };

    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      // this.recordTypeId = this.route.snapshot.params.id;
      // this.recordTypeName = this.route.snapshot.params.name;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      this.mode = this.route.snapshot.params.mode;
      // this.id = this.route.snapshot.params.id;
    });
    console.log(this.metaobjectName);
    console.log(this.mode);

    this.guid = new GUID();

    this.getMetalayout().then(() => {
      console.log(this.layoutList);
      this.loaded = true;
    });

    // this.getMetaProfileLayouts().then(() => {
    // });

    this.getActiveProfiles().then(() => {
      this.getMetaProfileLayouts().then(() => {
        console.log(this.profileList);
        // this.profileList = this.profileList;
        this.profileList.forEach((eachProfile, prfileIndex, profileArray) => {
          let pageLayoutAssignmentObject = {};
          pageLayoutAssignmentObject["profilename"] = eachProfile.name;
          pageLayoutAssignmentObject["profileid"] = eachProfile.id;
          pageLayoutAssignmentObject["layouts"] = [];
          // this.dbData['pagelayoutassignment']
          console.log(this.recordTypeLayout);
          console.log(this.recordTypeList);

          this.recordTypeList.forEach(
            (eachRecordType, recordTypeIndex, recordTypeArray) => {
              const matchingLayout = this.recordTypeLayout.find(
                (layout) =>
                  layout.recordtypeid === eachRecordType.id &&
                  layout.profileid === eachProfile.id
              );
              console.log(matchingLayout);
              // let eachRecordTypeLayout = {};
              // eachRecordTypeLayout["recordtypeid"] = eachRecordType.id;
              // eachRecordTypeLayout["recordtypename"] = eachRecordType.name;
              // eachRecordTypeLayout["layoutname"] = matchingLayout.metalayoutname;
              // eachRecordTypeLayout["layoutid"] = matchingLayout.metalayoutid;
              // eachRecordTypeLayout["profilename"] = eachProfile.name;
              // eachRecordTypeLayout["profileid"] = eachProfile.id;
              // eachRecordTypeLayout["selected"] = false;
              // eachRecordTypeLayout["changed"] = false;
              let eachRecordTypeLayout = {
                recordtypeid: eachRecordType.id,
                recordtypename: eachRecordType.name,
                layoutname: matchingLayout
                  ? matchingLayout.metalayoutname
                  : "--None--",
                layoutid: matchingLayout ? matchingLayout.metalayoutid : "",
                profilename: eachProfile.name,
                profileid: eachProfile.id,
                selected: false,
                changed: false,
              };

              // pageLayoutAssignmentObject['layouts'].push(JSON.parse(JSON.stringify(eachRecordType)))
              pageLayoutAssignmentObject["layouts"].push(eachRecordTypeLayout);

              console.log(eachRecordTypeLayout);
            }
          );
          this.dbData["pagelayoutassignment"].push(pageLayoutAssignmentObject);
        });

        // this.getMetaProfileLayouts().then(() => {
        // });
      });
    });

    this.getRecordTypes().then(() => {
      // console.log(this.recordTypeList);
      this.recordTypeList.forEach(
        (eachRecordType, recordTypeIndex, recordTypeArray) => {
          // alert(eachRecordType/.name)
          this.allSelected[recordTypeIndex] = false;
        }
      );
    });

    this.getRecordTypeLayouts().then(() => {});

    this.getActiveProfiles().then(() => {
      this.getMetaProfileLayouts().then(() => {
        // console.log(this.metaProfileLayout)

        // console.log(this.profileLayoutList);
        // console.log( this.metaProfileLayout)

        // this.profileList = this.profileList;
        this.profileLayoutList.forEach(
          (eachProfile, prfileIndex, profileArray) => {
            let pageLayoutAssignmentObject1 = {};
            pageLayoutAssignmentObject1["profilename"] = eachProfile.name;
            pageLayoutAssignmentObject1["profileid"] = eachProfile.id;
            const matchingMetaProfileLayout = this.metaProfileLayout.find(
              (layout) => layout.profileid === eachProfile.id
            );

            // Assign metalayoutid from matching metaProfileLayout
            if (matchingMetaProfileLayout) {
              pageLayoutAssignmentObject1["layoutid"] =
                matchingMetaProfileLayout.metalayoutid;
            }

            // console.log(matchingMetaProfileLayout)
            pageLayoutAssignmentObject1["layout"] = [];
            // pageLayoutAssignmentObject["changed"] = false;

            // console.log(this.profileLayoutList)
            // console.log( this.metaProfileLayout)

            // this.dbData['pagelayoutassignment']

            this.profileLayoutList.forEach(
              (eachProfileLayout, recordTypeIndex, recordTypeArray) => {
                const matchingLayout = this.metaProfileLayout.find(
                  (layout) =>
                    // layout.recordtypeid === eachRecordType.id &&
                    layout.profileid === eachProfileLayout.id
                );
                let eachRecordTypeLayout = {};
                // console.log(this.metaProfileLayout)
                // console.log(eachProfileLayout)
                // eachRecordTypeLayout["recordtypeid"] = eachRecordType.id;
                // eachRecordTypeLayout["recordtypename"] = eachRecordType.name;
                // console.log(matchingLayout)
                // eachRecordTypeLayout["layoutname"] = matchingLayout.metalayoutid;
                // eachRecordTypeLayout["layoutid"] = matchingLayout.metalayoutid;
                eachRecordTypeLayout["profilename"] = eachProfile.name;
                eachRecordTypeLayout["profileid"] = eachProfile.id;
                eachRecordTypeLayout["selected"] = false;
                eachRecordTypeLayout["changed"] = false;

                // pageLayoutAssignmentObject['layouts'].push(JSON.parse(JSON.stringify(eachRecordType)))
                pageLayoutAssignmentObject1["layout"].push(
                  eachRecordTypeLayout
                );

                // console.log(eachRecordTypeLayout);
              }
            );
            this.dbData1["layoutassignment"].push(pageLayoutAssignmentObject1);
            // console.log(this.dbData1)
          }
        );
      });
    });

    // this.getMetalayout();
    // console.log(this.layoutList )

    // this.recordTypeList.forEach((eachRecordType, recordTypeIndex, recordTypeArray) => {
    //   // alert(eachRecordType/.name)
    //   this.allSelected[recordTypeIndex] = false
    // })
    // this.profileList.forEach((eachProfile, prfileIndex, profileArray) => {
    //   let pageLayoutAssignmentObject = {}
    //   pageLayoutAssignmentObject['profilename'] = eachProfile.name
    //   pageLayoutAssignmentObject['profileid'] = eachProfile.id
    //   pageLayoutAssignmentObject['layouts'] = []
    //   // this.dbData['pagelayoutassignment']
    //   this.recordTypeList.forEach((eachRecordType, recordTypeIndex, recordTypeArray) => {
    //     let eachRecordTypeLayout = {}
    //     eachRecordTypeLayout['recordtypeid'] = eachRecordType.id
    //     eachRecordTypeLayout['recordtypename'] = eachRecordType.name
    //     eachRecordTypeLayout['layoutname'] = this.metaobjectName + ' Layout'
    //     eachRecordTypeLayout['layoutid'] = this.layoutId
    //     eachRecordTypeLayout['selected'] = false
    //     eachRecordTypeLayout['changed'] = false

    //     // pageLayoutAssignmentObject['layouts'].push(JSON.parse(JSON.stringify(eachRecordType)))
    //     pageLayoutAssignmentObject['layouts'].push(eachRecordTypeLayout)

    //     console.log(eachRecordTypeLayout)

    //   })
    //   this.dbData['pagelayoutassignment'].push(pageLayoutAssignmentObject)
    // });
    console.log(this.profileList);

    // console.log(eachRecordTypeLayout)
  }

  // changeLayout1(event: any): void {
  //   // Your existing logic for handling layout change
  //   // For example, update 'selected' based on the selected layout
  //   this.selected = event.value;
  //   console.log(this.selected)
  // }
  // selectProfile(element: any): void {
  //   // Check if element is defined and has the expected properties
  //   console.log(element)
  //   if (element && element.hasOwnProperty('isSelected') && element.hasOwnProperty('layoutid')) {
  //     // Update layoutid based on the selected layout
  //     if (element.isSelected) {
  //       // Your logic to assign layoutid goes here
  //       element.layoutid = this.selected
  //     } else {
  //       // Handle the case when the checkbox is unchecked if needed
  //       // For example, you may want to set layoutid to null or a default value
  //       element.layoutid = null; // or set to a default value
  //     }

  //     // Your existing logic for handling the selection change goes here
  //     // ...

  //     // Optionally, you can log the updated data
  //     console.log('Updated Data:', this.dataSource);
  //   }
  // }

  changeLayout1(event: any): void {
    // Your existing logic for handling layout change
    // For example, update 'selected' based on the selected layout
    this.selectedId = event.value;
    this.selectedName = event.source.triggerValue;
    // Update layoutid for all elements
    for (const element of this.dataSource.data) {
      if (
        element.hasOwnProperty("isSelected") &&
        element.hasOwnProperty("layoutid")
      ) {
        if (element["isSelected"]) {
          // Your logic to assign layoutid goes here
          element["layoutid"] = this.selectedId;
          element["layoutname"] = this.selectedName;
        } else {
          // Handle the case when the checkbox is unchecked if needed
          // For example, you may want to set layoutid to null or a default value
          element["layoutid"] = element["layoutid"]; // or set to a default value
          element["layoutname"] = element["layoutname"]; // or set to a default value
        }
      }
    }

    console.log(this.selectedId);
    console.log(this.selectedName);
    console.log(this.dataSource.data);
  }

  selectProfile(element: any): void {
    // Check if element is defined and has the expected properties
    console.log(element);
    if (
      element &&
      element.hasOwnProperty("isSelected") &&
      element.hasOwnProperty("layoutid")
    ) {
      // Update layoutid based on the selected layout
      if (element.isSelected) {
        // Your logic to assign layoutid goes here
        element.layoutid = this.selected;
      } else {
        // Handle the case when the checkbox is unchecked if needed
        // For example, you may want to set layoutid to null or a default value
        element.layoutid = null; // or set to a default value
      }

      // Store the selected element for later reference in changeLayout1
      if (element.isSelected) {
        this.selectedElement = element;
      } else {
        this.selectedElement = null;
      }

      // Your existing logic for handling the selection change goes here
      // ...

      // Optionally, you can log the updated data
      console.log("Updated Data:", this.dataSource);
    }
  }

  displayedColumns: string[] = ["profilename", "layoutname"];
  dataSource = new MatTableDataSource();

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  selected = 0;
  selectLayout(rowIndex, columnIndex) {
    // alert(rowIndex+' '+columnIndex+" "+JSON.stringify(this.allSelected))
    if (rowIndex != -1) {
      if (
        this.dbData["pagelayoutassignment"][rowIndex]["layouts"][columnIndex][
          "selected"
        ]
      ) {
        this.selected += 1;
      } else {
        this.selected -= 1;
      }
    } else {
      if (this.allSelected[columnIndex]) {
        this.dbData["pagelayoutassignment"].forEach(
          (eachRow, rowIndex, profileArray) => {
            if (
              !this.dbData["pagelayoutassignment"][rowIndex]["layouts"][
                columnIndex
              ]["selected"]
            )
              this.selected++;
            this.dbData["pagelayoutassignment"][rowIndex]["layouts"][
              columnIndex
            ]["selected"] = this.allSelected[columnIndex];
          }
        );
      } else {
        this.dbData["pagelayoutassignment"].forEach(
          (eachRow, rowIndex, profileArray) => {
            if (
              this.dbData["pagelayoutassignment"][rowIndex]["layouts"][
                columnIndex
              ]["selected"]
            )
              this.selected--;
            this.dbData["pagelayoutassignment"][rowIndex]["layouts"][
              columnIndex
            ]["selected"] = this.allSelected[columnIndex];
          }
        );
      }
    }
    // Finally, set the header checkbox to false
    // this.allSelected[columnIndex] = false;
  }

  changed = 0;
  changeLayout(event: any) {
    console.log(event);
    this.dbData["pagelayoutassignment"].map(
      (eachProfile, profileIndex, profileArray) => {
        eachProfile["layouts"].forEach(
          (eachRecordType, recordTypeIndex, recordTypeArray) => {
            if (
              this.dbData["pagelayoutassignment"][profileIndex]["layouts"][
                recordTypeIndex
              ]["selected"]
            ) {
              this.dbData["pagelayoutassignment"][profileIndex]["layouts"][
                recordTypeIndex
              ]["layoutname"] = event.source.triggerValue;
              this.dbData["pagelayoutassignment"][profileIndex]["layouts"][
                recordTypeIndex
              ]["layoutid"] = event.value;
              if (
                !this.dbData["pagelayoutassignment"][profileIndex]["layouts"][
                  recordTypeIndex
                ]["changed"]
              )
                this.changed += 1;
              this.dbData["pagelayoutassignment"][profileIndex]["layouts"][
                recordTypeIndex
              ]["changed"] = true;
              this.dbData["pagelayoutassignment"][profileIndex]["layouts"][
                recordTypeIndex
              ]["selected"] = false;
              this.selected -= 1;
            }
          }
        );
      }
    );

    console.log(this.dbData["pagelayoutassignment"]);
    console.log(this.dbData);

    // var recordtypeLayoutAssignments = this.dbData.pagelayoutassignment.layouts
    // console.log(recordtypeLayoutAssignments)

    // alert(rowIndex+' '+columnIndex)
    // if(this.dbData['pagelayoutassignment'][rowIndex]['layouts'][columnIndex]['selected']){
    // this.dbData['pagelayoutassignment'][rowIndex]['layouts'][columnIndex]['selected']=false
    // this.selected-=1
    // }
    // else{
    //   this.dbData['pagelayoutassignment'][rowIndex]['layouts'][columnIndex]['selected']=true
    //   this.selected+=1
    // }
    // this.allSelected[0] = false;

    // 🔴 Uncheck all header checkboxes (for object `allSelected`)
    Object.keys(this.allSelected).forEach((key) => {
      this.allSelected[key] = false;
    });
  }

  getActiveProfiles() {
    return new Promise((resolve, reject) => {
      console.log("getActiveProfiles");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          profile: {
            userlicense: localStorage.getItem("crm_userlicense"),
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveProfileByUserLicense(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.profileList = res.data.profiles;
            this.profileLayoutList = res.data.profiles;
            // this.isLoading = false;
            resolve(null);
          } else {
            console.log("No profile data!");
            this.errorMessage = res != null ? res.message : "No profile data!";
            this.isError = true;
            // this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getMetalayout() {
    return new Promise((resolve, reject) => {
      console.log("getMetalayout");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          // sortfield: this.sorting.fieldName,
          // sortorder: this.sorting.order,
          metalayout: {
            metaobjectid: this.metaobjectId,
            // layouttype: "Page Layout",
            // name: "AcademicSession_New_general",
          },
        },
      };
      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getLayouts(postOption).subscribe(
        (res) => {
          console.log("metalayout list", res);
          if (res !== null && res.success == 1) {
            // this.metalayoutList = res.data.metalayouts;
            this.metalayoutList = res.data.metalayouts.filter(
              (layout) =>
                layout.layouttype === null ||
                layout.layouttype === "Page Layout" ||
                layout.layouttype === "undefined"
            );

            if (res !== null && res.success == 1) {
              // var activelayout = res.data.metalayouts;

              var activelayout = res.data.metalayouts.filter(
                (layout) =>
                  layout.layouttype === null ||
                  layout.layouttype === "Page Layout" ||
                  layout.layouttype === "undefined"
              );

              var layoutArr = [];
              //just add an empty entry sice this field is optional
              layoutArr.push({ value: "", label: "--None--" });
              for (let i = 0; i < activelayout.length; i++) {
                layoutArr.push({
                  value: activelayout[i].id,
                  label: activelayout[i].name,
                });
              }
              this.layoutList = layoutArr;

              console.log(this.layoutList);

              // this.isLoading = false;
              resolve(null);
            } else {
              console.log("No process data!");
              this.errorMessage =
                res != null ? res.message : "No process data!";
              this.isError = true;
              // this.isLoading = false;
              resolve(null);
            }
            // console.log(this.metalayoutList);

            // this.isLoading = false;
            resolve(null);
          } else {
            console.log("No layouts data!");
            this.errorMessage = res != null ? res.message : "No layouts data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getRecordTypes() {
    return new Promise((resolve, reject) => {
      console.log("getRecordTypes");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          // sortfield: this.sortingField.fieldName,
          // sortorder: this.sortingField.order,
          recordtype: {
            metaobjectid: this.metaobjectId,
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getRecordTypes(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.recordTypeList = res.data.recordtypes;
            //assign table data will refresh it automatically
            // this.dataSource.data = this.recordTypeList;

            // this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metafields data!");
            this.errorMessage =
              res != null ? res.message : "No metafields data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getRecordTypeLayouts() {
    return new Promise((resolve, reject) => {
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          recordtypelayout: {
            metaobjectid: this.metaobjectId,
          },
        },
      };

      this.isLoading = true;
      console.log(postOption);
      this.dataService.getRecordTypeLayouts(postOption).subscribe(
        (res) => {
          //alert('****res****' + JSON.stringify(res));
          console.log(res);

          if (res.success == 1) {
            // this.recordTypeLayout = res.data.recordtypelayout;
            console.log(this.recordTypeLayout);
          } else {
            console.log("no data");
            // this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
        }
      );
    });
  }

  getMetaProfileLayouts() {
    return new Promise((resolve, reject) => {
      console.log("getMetaProfileLayouts");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          // sortfield: this.sortingField.fieldName,
          // sortorder: this.sortingField.order,
          metaprofilelayout: {
            metaobjectid: this.metaobjectId,
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      console.log(this.profileList);

      this.dataService.getMetaProfileLayouts(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.metaProfileLayout = res.data.metaprofilelayout;
            this.recordTypeLayout = res.data.metaprofilelayout;
            //assign table data will refresh it automatically
            // this.dataSource.data = this.recordTypeList;
            console.log(this.metaProfileLayout);
            console.log(this.profileList);
            console.log(this.metalayoutList);

            const profileMap = {};
            this.profileList.forEach((profile) => {
              profileMap[profile.id] = profile;
            });

            const layoutMap = {};
            this.metalayoutList.forEach((layout) => {
              layoutMap[layout.id] = layout;
            });
            const uniqueProfileIds = [];

            // Update dataSource.data based on the matching profiles
            this.dataSource.data = this.metaProfileLayout
              .map((item) => {
                const matchingProfile = profileMap[item.profileid];
                const matchingLayout = layoutMap[item.metalayoutid];

                // Check if the profileid is already in the dataSource
                if (!uniqueProfileIds.includes(item.profileid)) {
                  uniqueProfileIds.push(item.profileid);

                  return {
                    profilename: matchingProfile ? matchingProfile.name : "", // Use the name if a match is found, otherwise an empty string
                    layoutname: matchingLayout ? matchingLayout.name : "",
                    profileid: matchingProfile ? matchingProfile.id : "",
                    layoutid: matchingLayout ? matchingLayout.id : "",

                    // Add other properties as needed
                  };
                } else {
                  return null; // Skip adding this item to dataSource as profileid is already present
                }
              })
              .filter(Boolean);

            // this.dataSource.data = this.metaProfileLayout.map(item => {
            //   const matchingProfile = profileMap[item.profileid];
            //   const matchingLayout = layoutMap[item.metalayoutid];
            //   console.log(matchingProfile)
            //   console.log(matchingLayout)

            //   return {
            //     profilename: matchingProfile ? matchingProfile.name : '', // Use the name if a match is found, otherwise an empty string
            //     layoutname: matchingLayout ? matchingLayout.name : '',
            //     profileid: matchingProfile ? matchingProfile.id : '',
            //     layoutid: matchingLayout ? matchingLayout.id : '',

            //     // Add other properties as needed
            //   };
            // });

            // console.log(this.dataSource.data)

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metaprofilelayout data!");
            this.errorMessage =
              res != null ? res.message : "No metaprofilelayout data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  cancel() {
    this.router.navigateByUrl(
      "home/metaobjectdetail/" + this.metaobjectId + "/" + this.metaobjectName
    );
  }
  save() {
    this.isLoading = false;
    this.isError = false;

    // if (this.detailForm.controls["displayname"].value.toString().trim() == "") {
    //   this.showWarning("Recordtype label is mandatory");
    //   return;
    // }
    // if (this.detailForm.controls["name"].value.toString().trim() == "") {
    //   this.showWarning("Recordtype name is mandatory");
    //   return;
    // }

    // if (this.detailForm.invalid) {
    //   this.errorMessage = "The fields [Label] and [Name] are mandatory.";
    //   return;
    // }

    console.log("mode", this.mode);
    // for (var recordTypeLayout of this.dbData.pagelayoutassignment) {
    //   if (
    //     this.mode.toLowerCase() == "new" ||
    //     this.mode.toLowerCase() == "edit"
    //   ) {
    //     this.recordTypeLayoutId = this.guid.getGUID("recordtypelayout");
    //   }
    // }

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        metaobjectid: this.metaobjectId,
        mode: this.mode,
        metaprofilelayouts: [],
        metaprofilelayoutwebs: [],

        // metaobjectid: this.metaobjectId,
        // mode:this.mode,
        // layout: [], // Initialize outside the loop
      },
    };

    if (this.recordTypeList && this.recordTypeList.length > 0) {
      for (var recordTypeAssignment of this.dbData["pagelayoutassignment"]) {
        if (
          this.mode.toLowerCase() == "new" ||
          this.mode.toLowerCase() == "edit"
        ) {
          for (var layout of recordTypeAssignment.layouts) {
            console.log(layout);
            // Skip if layoutid is empty or only whitespace
            if (!layout.layoutname || layout.layoutname.trim() === "--None--") {
              continue; // skip this layout
            }
            layout.metaProfileLayoutId = this.guid.getGUID("metaprofilelayout");

            const metaprofilelayout = {
              id: layout.metaProfileLayoutId, // Use the layout ID you generated
              embeddedobject: false,
              parentobjectid: "",
              mode: this.mode,
              metalayoutid: layout.layoutid,
              recordtypeid: layout.recordtypeid,
              metalayoutname: layout.layoutname,
              recordtypename: layout.recordtypename,
              profileid: layout.profileid,
              profilename: layout.profilename,
              userid: null,
              description: "",
              actiontype: "New",
              active: true,
              layouttype: "Page Layout",
              attributes: {},
              mastertype: false,
              metaobjectid: this.metaobjectId,
            };

            postOption.data.metaprofilelayouts.push(metaprofilelayout);

            this.metaProfileLayoutWebId = this.guid.getGUID(
              "metaprofilelayoutweb"
            );

            const metaProfileLayoutWeb = {
              id: this.metaProfileLayoutWebId,
              metaobjectid: this.metaobjectId,
              metaobjectname: this.metaobjectName,
              embeddedobject: false,
              parentobjectid: "",
              metalayoutid: layout.layoutid,
              metalayoutname: layout.layoutname,
              recordtypeid: layout.recordtypeid,
              recordtypename: layout.recordtypename,
              profileid: layout.profileid,
              profilename: layout.profilename,
              userid: null,
              username: "",
              description: "",
              actiontype: "New",
              active: true,
              layouttype: "Page Layout",
              layoutjsontext: {},
              fieldjsontext: {},
              criteriajsontext: {},
            };
            postOption.data.metaprofilelayoutwebs.push(metaProfileLayoutWeb);
          }
        }
      }

      console.log("postOption", postOption);
    } else {
      console.log(this.dataSource.data);

      // let postOption = {
      //   organizationid: localStorage.getItem("crm_orgid"),
      //   userid: localStorage.getItem("crm_userid"),
      //   username: localStorage.getItem("crm_username"),
      //   useralias: localStorage.getItem("crm_useralias"),
      //   data: {
      //     metaprofilelayouts:[],
      //     metaprofilelayoutwebs:[]

      //       // metaobjectid: this.metaobjectId,
      //       // mode:this.mode,
      //       // layout: [], // Initialize outside the loop

      // },
      // };

      for (var recordTypeAssignment of this.dataSource.data) {
        console.log(recordTypeAssignment);

        if (
          this.mode.toLowerCase() == "new" ||
          this.mode.toLowerCase() == "edit"
        ) {
          // Skip if layoutid is empty
          if (
            !recordTypeAssignment.layoutid ||
            recordTypeAssignment.layoutid.trim() === ""
          ) {
            continue; // skip this recordTypeAssignment
          }
          // for (var layout of recordTypeAssignment) {
          recordTypeAssignment.metaProfileLayoutId =
            this.guid.getGUID("metaprofilelayout");

          const metaprofilelayout = {
            id: recordTypeAssignment.metaProfileLayoutId, // Use the layout ID you generated
            embeddedobject: false,
            parentobjectid: "",
            mode: this.mode,
            metalayoutid: recordTypeAssignment.layoutid,
            recordtypeid: null,
            metalayoutname: recordTypeAssignment.layoutname,
            recordtypename: null,
            profileid: recordTypeAssignment.profileid,
            profilename: recordTypeAssignment.profilename,
            userid: null,
            description: "",
            actiontype: "",
            active: true,
            layouttype: "Page Layout",
            attributes: {},
            mastertype: false,
            metaobjectid: this.metaobjectId,
          };

          postOption.data.metaprofilelayouts.push(metaprofilelayout);

          this.metaProfileLayoutWebId = this.guid.getGUID(
            "metaprofilelayoutweb"
          );

          const metaProfileLayoutWeb = {
            id: this.metaProfileLayoutWebId,
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName,
            embeddedobject: false,
            parentobjectid: "",
            metalayoutid: recordTypeAssignment.layoutid,
            metalayoutname: recordTypeAssignment.layoutname,
            recordtypeid: null,
            recordtypename: null,
            profileid: recordTypeAssignment.profileid,
            profilename: recordTypeAssignment.profilename,
            userid: null,
            username: "",
            description: "",
            actiontype: "",
            active: true,
            layouttype: "Page Layout",
            layoutjsontext: {},
            fieldjsontext: {},
            criteriajsontext: {},
          };
          postOption.data.metaprofilelayoutwebs.push(metaProfileLayoutWeb);

          // }
        }
      }

      console.log("postOption", postOption);
    }
    //prepare data for saving: application

    // console.log("postOption", postOption);

    this.isLoading = true;
    this.dataService.upsertRecordTypeLayout(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl(
            "/home/metaobjectdetail/" +
              this.metaobjectId +
              "/" +
              this.metaobjectName
          );
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
